import React from 'react';
import TEXTS from './texts.json';

export default {
  ...TEXTS,
  kcellBusiness: {
    ru: 'Kcell Бизнес',
    en: 'Kcell Business',
    kk: 'Kcell Бизнес',
  },
  bin: {
    ru: 'БИН ',
    en: 'BIN ',
    kk: 'БИН ',
  },
  PIA: {
    ru: 'Авансовый',
    en: 'Advance',
    kk: 'Аванстық',
  },
  POSTPAID: {
    ru: 'Кредитный',
    en: 'Credit',
    kk: 'Несиелік',
  },
  ACTIVE: {
    ru: <span className="state-active">Активный</span>,
    en: <span className="state-active">Active</span>,
    kk: <span className="state-active">Қосулы</span>,
  },
  ACTIVE_SINCE: date => ({
    ru: <span className="state-active">{ date ? `Активный с ${date}` : 'Активный'}</span>,
    en: <span className="state-active">{ date ? `Active since ${date}` : 'Active'}</span>,
    kk: <span className="state-active">{ date ? `${date} жылдан бастап қосулған` : 'Қосулы'}</span>,
  }),
  SUCCESS: {
    ru: <span className="state-active">Успешно</span>,
    en: <span className="state-active">Success</span>,
    kk: <span className="state-active">Қосулы</span>,
  },
  FAILURE: {
    ru: <span className="state-blocked">Ошибка</span>,
    en: <span className="state-blocked">Failure</span>,
    kk: <span className="state-blocked">Қате</span>,
  },
  SUSPENDED: {
    ru: <span className="state-blocked">Заблокирован</span>,
    en: <span className="state-blocked">Blocked</span>,
    kk: <span className="state-blocked">Бұғаттаулы</span>,
  },
  SUSPENDED_SINCE: date => ({
    ru: <span className="state-blocked">{ date ? `Заблокирован с ${date}` : 'Заблокирован'}</span>,
    en: <span className="state-blocked">{ date ? `Blocked since ${date}` : 'Blocked'}</span>,
    kk: <span className="state-blocked">{ date ? `${date} жылдан бастап бұғатталған` : 'Бұғаттаулы'}</span>,
  }),
  SUSPENDED_DUE_TO_DEBT_SINCE: date => ({
    ru: <span className="state-blocked">{ date ? `Заблокирован / Долг с ${date}` : 'Заблокирован / Долг' }</span>,
    en: <span className="state-blocked">{ date ? `Blocked / Debt since ${date}` : 'Blocked / Debt' }</span>,
    kk: <span className="state-blocked">{ date ? `${date} жылдан бастап бұғатталған/ Қарыз` : 'Бұғаттаулы / Қарыз' }</span>,
  }),
  SUSPENDED_DUE_TO_DEBT: {
    ru: <span className="state-blocked">Заблокирован / Долг</span>,
    en: <span className="state-blocked">Blocked / Debt</span>,
    kk: <span className="state-blocked">Бұғаттаулы / Қарыз</span>,
  },
  PENDING: {
    ru: <span className="state-pending ">В обработке</span>,
    en: <span className="state-pending ">Processing</span>,
    kk: <span className="state-pending ">Өңделуде</span>,
  },
  INTERNET: {
    ru: 'Интернет',
    en: 'Internet',
    kk: 'Интернет',
  },
  VOICE: {
    ru: 'Голос',
    en: 'Voice',
    kk: 'Дауыс',
  },
  number: {
    ru: 'Номер',
    en: 'Number',
    kk: 'Нөмір',
  },
  accountNumber: {
    ru: 'Лицевой счет',
    en: 'Account number',
    kk: 'Дербес шот нөмірі',
  },
  tariffPlan: {
    ru: 'Тарифный план',
    en: 'Tariff plan',
    kk: 'Тарифтік жоспар',
  },
  status: {
    ru: 'Статус',
    en: 'State',
    kk: 'Жай-күйі',
  },
  usageDetails: {
    ru: 'Детализация',
    en: 'Usage details',
    kk: 'Детализация',
  },
  usageDetailsDesc: {
    ru: 'Выберите период и способ отображения детализации. Данные для выгрузки доступны за последние 90 дней, включая текущий. Детализация вызовов за текущие сутки может быть неполной в связи с периодичностью обновления данных.',
    en: "Select period and method to display usage details. Data is available for the past 90 days, including current day. Today's call details may be incomplete, as they do not appear in your account immediately.",
    kk: 'Шот деректерін көрсету кезеңі мен тәсілін таңдаңыз. Шығарылатын деректер, ағымдағы кунді қоса алғанда, соңғы 90 күнге қолжетімді. Деректердің жаңару мерзімділігіне байланысты, ағымдағы күні шалынған қоңыраулар деректері толық болмауы мүмкін.',
  },
  beginAndEndPeriod: {
    ru: 'Начало и конец периода',
    en: 'Beginning and end of period',
    kk: 'Кезеңнің басталуы мен аяқталуы',
  },
  usageDetailsEmpty: {
    ru: 'Детализация за данный период не найдена',
    en: 'Usage details for this period are not found',
    kk: 'Бұл кезең үшін шот деректері табылмады',
  },
  onScreen: {
    ru: 'На экран',
    en: 'On screen',
    kk: 'Экранға',
  },
  pdf: {
    ru: 'Файл формата PDF',
    en: 'PDF file',
    kk: 'PDF форматты файл',
  },
  xls: {
    ru: 'Файл формата XLS',
    en: 'XLS file',
    kk: 'XLS форматты файл',
  },
  request: {
    ru: 'Запросить',
    en: 'Request',
    kk: 'Сұрату',
  },
  requestUsdet: {
    ru: 'Запросить детализацию',
    en: 'Request itemized bill',
    kk: 'Деректерді сұрату',
  },
  dateTime: {
    ru: 'Дата/время',
    en: 'Date/Time',
    kk: 'Күні/уақыты',
  },
  type: {
    ru: 'Тип',
    en: 'Type',
    kk: 'Түрі',
  },
  description: {
    ru: 'Описание',
    en: 'Description',
    kk: 'Сипаттама',
  },
  duration: {
    ru: 'Длительность',
    en: 'Duration',
    kk: 'Ұзақтығы',
  },
  units: {
    ru: 'Единицы',
    en: 'Units',
    kk: 'Бірлік',
  },
  amount: {
    ru: 'Стоимость',
    en: 'Amount',
    kk: 'Құны',
  },
  simChange: {
    ru: 'Замена Sim-карты',
    en: 'SIM card replacement',
    kk: 'SIM картаны ауыстыру',
  },
  simChangeLabel: {
    ru: 'Введите новый номер SIM-карты',
    en: 'Enter new SIM card number',
    kk: 'Жаңа SIM картаның нөмірін енгізіңіз',
  },
  simChangeDesc: {
    ru: 'Для замены введите 20-ти значный номер новой SIM карты',
    en: 'To replace SIM card enter 20-digit new SIM card number',
    kk: 'SIM картаны ауыстыру үшін 20 таңбалы жаңа SIM карта нөмірін енгізіңіз',
  },
  block: {
    ru: 'Блокировка',
    en: 'Block',
    kk: 'Бұғаттау',
  },
  unblock: {
    ru: 'Разблокировка',
    en: 'Unblock',
    kk: 'Бұғаттан шығару',
  },
  numberInfo: {
    ru: 'Информация по номеру',
    en: 'Number information',
    kk: 'Нөмір бойынша ақпарат',
  },
  limit: {
    ru: 'Лимит',
    en: 'Limit',
    kk: 'Лимит',
  },
  paymentMethod: {
    ru: 'Метод расчета',
    en: 'Method of payment',
    kk: 'Есеп айырысу әдісі',
  },
  roamingDebt: {
    ru: 'Задолженность за роуминг',
    en: 'Outstanding amount for roaming',
    kk: 'Роуминг үшін берешек',
  },
  availableBalance: {
    ru: 'Доступные средства',
    en: 'Available balance',
    kk: 'Қолжетімді қаражат',
  },
  toPaid: {
    ru: 'Сумма к оплате',
    en: 'Amount payable',
    kk: 'Төленетін сома',
  },
  debt: {
    ru: 'Задолженность',
    en: 'Outstanding amount',
    kk: 'Берешек',
  },
  creditLimit: {
    ru: 'Кредитный лимит',
    en: 'Credit limit',
    kk: 'Несиелік лимит',
  },
  individualLimit: {
    ru: 'Индивидуальный лимит',
    en: 'Individual limit',
    kk: 'Жеке лимит',
  },
  totalDebt: {
    ru: 'Общая задолженность',
    en: 'Total debt',
    kk: 'Жалпы берешек',
  },
  tariff: {
    ru: 'Тариф',
    en: 'Tariff',
    kk: 'Тариф',
  },
  paymentTerms: {
    ru: 'Информация для оплаты',
    en: 'Payment terms',
    kk: 'Төлем ақпараты',
  },
  eRegister: {
    ru: 'Электронный реестр',
    en: 'E-register',
    kk: 'Электрондық тізім',
  },
  applicationSamples: {
    ru: 'Образцы заявлений',
    en: 'Applications samples',
    kk: 'Өтініш үлгілері',
  },
  contacts: {
    ru: 'Контакты',
    en: 'Contacts',
    kk: 'Байланыстар',
  },
  footerText: {
    ru: ' © АО Kcell 2000-2019. Государственная лицензия № ДС0000270 от 08.06.1998, '
        + '          бессрочная, выдана Министерством транспорта и коммуникаций Республики Казахстан',
    en: '© Kcell JSC 2000–2019. State license No. ДС0000270 of 08.06.1998, perpetual,'
        + ' issued by the Ministry of Transport and Communications of the Republic of Kazakhstan.',
    kk: '© «Кселл» АҚ 2000–2019. Қазақстан Республикасының Көлік және коммуникация '
        + 'министрлігі 08.06.1998 берген мемлекеттік лицензия № ДС0000270, мерзімсіз.',
  },
  selectCompany: {
    ru: 'Выбор компании',
    en: 'Select company',
    kk: 'Компания таңдау',
  },
  selectLang: {
    ru: 'Выбор языка',
    en: 'Choose lang',
    kk: 'Тілді таңдау',
  },
  chooseService: {
    ru: 'Выбор услуги',
    en: 'Choose service',
    kk: 'Қызметті таңдау',
  },
  myProfile: {
    ru: 'Мой профиль',
    en: 'My profile',
    kk: 'Менің профилім',
  },
  exit: {
    ru: 'Выйти',
    en: 'Exit',
    kk: 'Шығу',
  },
  search: {
    ru: 'Поиск',
    en: 'Search',
    kk: 'Іздеу',
  },
  blockNumber: {
    ru: 'Заблокировать номер',
    en: 'Block number',
    kk: 'Нөмірді бұғаттау',
  },
  unblockNumber: {
    ru: 'Разблокировать номер',
    en: 'Unblock number',
    kk: 'Нөмірді бұғаттан шығару',
  },
  blockSure: {
    ru: 'Вы уверены, что хотите заблокировать данный номер?',
    en: 'Are you sure you want to block this account?',
    kk: 'Осы нөмірді бұғаттағыңыз келетіндігіне сенімдісіз бе?',
  },
  unblockSure: {
    ru: 'Вы уверены, что хотите разблокировать данный номер?',
    en: 'Are you sure you want to unblock this account?',
    kk: 'Осы нөмірді бұғаттан шығарғыңыз келетіндігіне сенімдісіз бе?',
  },
  yesSure: {
    ru: 'Да, уверен',
    en: 'Yes, I am sure',
    kk: 'Иә, сенімдімін',
  },
  cancel: {
    ru: 'Отменить',
    en: 'Cancel',
    kk: 'Бас тарту',
  },
  generalInfo: {
    ru: 'Общая информация',
    en: 'General information',
    kk: 'Жалпы ақпарат',
  },
  regForm: {
    ru: 'Регистрационная форма',
    en: 'Registration form',
    kk: 'Тіркеу нысаны',
  },
  simCard: {
    ru: 'SIM карта и устройство',
    en: 'SIM card and device',
    kk: 'SIM карта және құрал',
  },
  unlimited: {
    ru: 'Безлимит',
    en: 'Unlimited',
    kk: 'Шектеусіз',
  },
  available: {
    ru: 'Доступно',
    en: 'Available',
    kk: 'Қол жетімді',
  },
  total: {
    ru: 'Всего',
    en: 'Total',
    kk: 'Барлығы',
  },
  connDate: {
    ru: 'Дата подключения',
    en: 'Connection date',
    kk: 'Қосылу күні',
  },
  disconnDate: {
    ru: 'Дата отключения',
    en: 'Disconnect date',
    kk: 'Ажырату күні',
  },
  validity: {
    ru: 'Срок действия',
    en: 'Validity',
    kk: 'Жарамдылық мерзімі',
  },
  bonuses: {
    ru: 'Бонусы',
    en: 'Bonuses',
    kk: 'Бонустар',
  },
  enable: {
    ru: 'Подключить',
    en: 'Enable',
    kk: 'Қосылу',
  },
  enabled: {
    ru: 'Подключено',
    en: 'Enabled',
    kk: 'Қосылды',
  },
  disable: {
    ru: 'Отключить',
    en: 'Disable',
    kk: 'Өшіру',
  },
  disabled: {
    ru: 'Отключено',
    en: 'Disabled',
    kk: 'Өшірілген',
  },
  MONTHLY_FEE: {
    ru: 'Ежемесячная абонентская плата',
    en: 'Monthly fee',
    kk: 'Ай сайынғы абоненттік төлем',
  },
  DAILY_FEE: {
    ru: 'Ежедневная абонентская плата',
    en: 'Daily fee',
    kk: 'Күн сайынғы абоненттік төлем',
  },
  ONE_TIME_FEE: {
    ru: 'Стоимость',
    en: 'Cost',
    kk: 'Құны',
  },
  trafficVolume: {
    ru: 'Объем трафика',
    en: 'Traffic volume',
    kk: 'Трафик көлемі',
  },
  sureEnable: name => ({
    ru: `Вы уверены, что хотите подключить услугу "${name}"?`,
    en: `Are you sure you want to activate "${name}" service?`,
    kk: `Сіз "${name}" қызметін қосқыңыз келетіндігіне сенімдісіз бе?`,
  }),
  sureDisable: name => ({
    ru: `Вы уверены, что хотите отключить услугу "${name}"?`,
    en: `Are you sure you want to deactivate "${name}" service?`,
    kk: `Сіз "${name}" қызметін ажырату келетіндігіне сенімдісіз бе?`,
  }),
  enabledServices: {
    ru: 'Подключенные услуги',
    en: 'Connected services',
    kk: 'Қосылган қызметтер',
  },
  availableServices: {
    ru: 'Доступные услуги',
    en: 'Available services',
    kk: 'Қол жетімді қызметтер',
  },
  pendingServices: {
    ru: 'Услуги в обработке',
    en: 'Pending services',
    kk: 'Өңдеу қызметтер',
  },
  systemError: {
    ru: 'Извините, сервис временно недоступен. Попробуйте повторить позднее.',
    en: 'Sorry, service is temporarily unavailable. Please, try again later.',
    kk: 'Кешіріңіз, сервис уақытша қолжетімсіз. Кейінірек қайталап көріңіз.',
  },
  blockSuccess: msisdn => ({
    ru: `Запрос на блокировку номера "${msisdn}" поставлен на обработку`,
    en: `Request for blocking account "${msisdn}" is being dealt with`,
    kk: `"${msisdn}" нөмірін бұғаттауға берілген сұраным өңдеуге қойылды.`,
  }),
  unblockSuccess: msisdn => ({
    ru: `Запрос на разблокировку номера "${msisdn}" поставлен на обработку`,
    en: `Request to unblock account "${msisdn}" is being dealt with.`,
    kk: `"${msisdn}" нөмірін бұғаттан шығаруға берілген сұраным өңдеуге қойылды.`,
  }),
  blockFailure: msisdn => ({
    ru: `Произошла системная ошибка во время блокировки номера "${msisdn}"`,
    en: `A system error occurred while locking the number "${msisdn}"`,
    kk: `"${msisdn}" нөмірін бұғаттау кезінде қате пайда болды`,
  }),
  unblockFailure: msisdn => ({
    ru: `Произошла системная ошибка во время разблокировки номера "${msisdn}"`,
    en: `A system error occurred while unlocking the number "${msisdn}"`,
    kk: `"${msisdn}" нөмірін бұғаттан шығару кезінде  қате пайда болды`,
  }),
  usageDetailsFailure: msisdn => ({
    ru: `Произошла системная ошибка при выгрузке детализации на номере "${msisdn}"`,
    en: `A system error occurred while uploading usage details for the number "${msisdn}"`,
    kk: `"${msisdn}" нөмірі үшін шот деректерін жүктеу кезінде қате пайда болды`,
  }),
  changeSimSuccess: msisdn => ({
    ru: `Запрос на смену SIM-карты с номером ${msisdn} поставлен на обработку"`,
    en: `Request to change SIM for account ${msisdn} is being dealt with.`,
    kk: `${msisdn} нөмірімен SIM-картаны ауыстыруға берілген сұраным өңдеуге қойылды`,
  }),
  changeSimFailure: msisdn => ({
    ru: `Произошла системная ошибка при смене SIM-карты с номером "${msisdn}"`,
    en: `A system error occurred while changing the SIM card for number "${msisdn}"`,
    kk: `"${msisdn}" нөмір үшін SIM картаны өзгерту кезінде қате пайда болды`,
  }),
  enableServiceSuccess: (service, msisdn) => ({
    ru: `Запрос на подключение услуги "${service}" на номере "${msisdn}" поставлен на обработку`,
    en: `Request for activation of "${service}" service on account "${msisdn}" is being dealt with.`,
    kk: `"${msisdn}" нөміріне "${service}" қызметін қосуға берілген өтінім өңдеуге қойылды`,
  }),
  enableServiceFailure: (service, msisdn) => ({
    ru: `Произошла системная ошибка при подключении услуги "${service}" на номере "${msisdn}"`,
    en: `A system error occurred while enabling the service "${service}" for the number "${msisdn}"`,
    kk: `"${service}" қызметін "${msisdn}" нөміріне қосу кезінде  қате пайда болды`,
  }),
  disableServiceSuccess: (service, msisdn) => ({
    ru: `Запрос на отключение услуги "${service}" на номере "${msisdn}" поставлен на обработку`,
    en: `Request for deactivation of "${service}" service on account "${msisdn}" is being dealt with.`,
    kk: `"${msisdn}" нөмірінен "${service}" қызметін өшіруге берілген өтінім өңдеуге қойылды`,
  }),
  disableServiceFailure: (service, msisdn) => ({
    ru: `Произошла системная ошибка при отключении услуги "${service}" на номере "${msisdn}"`,
    en: `A system error occurred while disabling the "${service}" service for the "${msisdn}" number`,
    kk: `"${service}" қызметін "${msisdn}" нөмірінде ажырату кезінде қате пайда болды`,
  }),
  serviceUnavailable: {
    ru: 'Извините, сервис временно недоступен. Попробуйте повторить позднее.',
    en: 'Sorry, service is temporarily unavailable. Please, try again later.',
    kk: 'Кешіріңіз, сервис уақытша қолжетімсіз. Кейінірек қайталап көріңіз.',
  },
  numberNotFound: {
    ru: 'Номер не найден. Для перехода к списку номеров очистите поле поиска  и нажмите на кнопку "Поиск"',
    en: 'Number not found. To go to the list of numbers, clear the search field and click on "Search" button',
    kk: 'Нөмір табылмады. Нөмірлер тізіміне өту үшін іздеу өрісін тазалап, «Іздеу» түймешігіне басыңыз',
  },
  display: {
    ru: 'Вывод',
    en: 'Display',
    kk: 'Шығару',
  },
  manageNumbers: {
    ru: 'Управление номерами',
    en: 'Number management',
    kk: 'Нөмірлерді басқару',
  },
  paymentHistory: {
    ru: 'История платежей',
    en: 'Payment History',
    kk: 'Төлемдер тарихы',
  },
  paymentHistoryAlert: {
    ru: 'Представлена история платежей по лицевым счетам с кредитным методом расчета, для получения информации по номерам с авансовым методом расчета - воспользуйтесь соответствующей услугой на странице управления номером.',
    en: 'The payments history includes payments for postpaid numbers only. To view payments history for prepaid numbers, please select appropriate service on the Number Management page.',
    kk: 'Есеп айырысудың несиелік әдісін қолданатын дербес шоттар бойынша төлемдер тарихы ұсынылады, есеп айырысудың алғытөлемдік әдісін қолданатын нөмірлер бойынша ақпарат алу үшін нөмірді басқару парағында тиісті қызметті пайдаланыңыз.',
  },
  paymentHistoryEmpty: {
    ru: 'История платежей за данный период не найдена',
    en: 'Payments history for this period are not found',
    kk: 'Бұл кезең үшін шот деректері табылмады',
  },
  sum: {
    ru: 'Сумма',
    en: 'Sum',
    kk: 'Сома',
  },
  offerAttention: {
    ru: 'Публичная оферта использования услуги «Кабинет»',
    en: 'Public Agreement on Online Account Service',
    kk: '«Кабинет» қызметін пайдаланудың жария офертасы',
  },
  offerWarning: {
    ru: 'Использование услуги невозможно без принятия условий оферты.',
    en: 'To use the service, you need to accept the terms and conditions of Public Agreement.',
    kk: 'Оферта талаптарын қабылдамайынша, қызметті пайдалану мүмкін болмайды.',
  },
  acceptOffer: {
    ru: 'Я принимаю условия оферты',
    en: 'I accept the terms and conditions of Public Agreement',
    kk: 'Мен оферта талаптарын қабылдаймын',
  },
  send: {
    ru: 'Отправить',
    en: 'Send',
    kk: 'Жолдау',
  },
  disabledButton: {
    ru: 'Данная функция недоступна при заблокированном номере',
    en: 'This feature is not available when the number is blocked',
    kk: 'Бұл мүмкіндік нөмір бұғатталған кезде қол жетімсіз',
  },
  moreInfo: {
    ru: 'Подробнее об услуге ',
    en: 'More about the service',
    kk: 'Қызмет туралы толығырақ',
  },
  totalSubscriptions: {
    ru: 'Количество доступных номеров',
    en: 'Available numbers',
    kk: 'Қолжетімді нөмірлердің саны',
  },
  docsAndReports: {
    ru: 'Документы и отчеты',
    en: 'Documents and reports',
    kk: 'Құжаттар мен есептер',
  },
  imeiDisclaimer: {
    ru: 'Указан последний зафиксированный IMEI код устройства, использовавшегося с данным номером.',
    en: 'This is the last IMEI of the device that has been used with this number.',
    kk: 'Осы нөмірмен пайдаланылған құрылғының соңғы тіркелген IMEI коды көрсетілген.',
  },
  topUpDetails: {
    ru: 'История платежей',
    en: 'Payment history',
    kk: 'Төлемдер тарихы',
  },
  requestTopUp: {
    ru: 'Запросить историю платежей',
    en: 'Request payment history',
    kk: 'Төлемдер тарихын сұрату',
  },
  topUpDownloadFailure: msisdn => ({
    ru: `Произошла системная ошибка при выгрузке истории платежей на номере "${msisdn}"`,
    en: `A system error occurred while uploading payment history for the number "${msisdn}"`,
    kk: `"${msisdn}" нөмірі үшін төлемдер тарихын жүктеу кезінде қате пайда болды`,
  }),
  topUpEmpty: {
    ru: 'История платежей за данный период не найдена',
    en: 'Payment history for this period are not found',
    kk: 'Бұл кезең үшін төлемдер тарихы табылмады',
  },
  comment: {
    ru: 'Комментарий',
    en: 'Comment',
    kk: 'Ескерту',
  },
  balanceBefore: {
    ru: 'Баланс до',
    en: 'Balance before',
    kk: 'Төлем алынғанға дейін',
  },
  balanceAfter: {
    ru: 'Баланс после',
    en: 'Balance after',
    kk: 'Төлем алынған соң',
  },
  deleteSecretCode: {
    ru: 'Удалить секретный код',
    en: 'Delete secret code',
    kk: 'Құпия кодты жою',
  },
  sendSecretCode: {
    ru: 'Отправить секретный код',
    en: 'Send secret code',
    kk: 'Құпия кодты жіберу',
  },
  deleteSecretCodeSure: {
    ru: 'Вы уверены, что хотите удалить секретный код?',
    en: 'Are you sure you want to delete secret code?',
    kk: 'Құпия кодты жойюға сенімдісіз бе?',
  },
  sendSecretCodeSure: {
    ru: 'Вы уверены, что хотите отправить секретный код?',
    en: 'Are you sure you want to send secret code?',
    kk: 'Құпия кодты жіберуге сенімдісіз бе?',
  },
  sendSecretCodeSuccess: {
    ru: 'Вы успешно выслали секретный код',
    en: 'You have successfully sent the secret code',
    kk: 'Сіз құпия кодты сәтті жібердіңіз',
  },
  deleteSecretCodeSuccess: {
    ru: 'Вы успешно удалили секретный код',
    en: 'You have successfully deleted the secret code',
    kk: 'Сіз құпия кодты сәтті жойдыңыз',
  },
  exportSubscribersLabel: {
    ru: 'Отчет по списку номеров',
    en: 'List of numbers report',
    kk: 'Нөмірлер тізімі бойынша есеб',
  },
  exportSubscribersDisclaimer: {
    ru: 'Подготовка данных может занять некоторое время. Сформированный отчет по списку номеров, будет отправлен на указанный Вами email. Время, на которое данные в отчете актуальны, будет указано в отправленном отчете.',
    en: 'Data preparation may take some time. The generated report by the list of numbers will be sent to the email you specified. The time at which the data in the report is relevant will be indicated in the report.',
    kk: 'Деректерді дайындауға біраз уақыт кетуі мүмкін. Нөмірлер тізімі бойынша жасалған есеп Сіз көрсеткен email жіберіледі. Уақыт жіберілген есепте көрсетіледі, ол үшін есептегі деректер маңызды болып табылады.',
  },
  exportSubscribersSuccess: {
    ru: 'Ваш запрос на отправку отчета принят.',
    en: 'Your request to submit a report has been accepted.',
    kk: 'Сіздің есепті жіберуге сұратымыңыз қабылданды.',
  },
  exportSubscribersError: {
    ru: 'Не удалось отправить отчет. Повторите попытку позднее или обратитесь в контакт-центр.',
    en: 'Failed to send the report. Please try again later or contact to contact center.',
    kk: 'Есеп жіберілмеді. Әрекетті қайталап көріңіз немесе байланыс орталығына хабарласыңыз.',
  },
  invalidEmailFormat: {
    ru: 'Неверный формат email',
    en: 'Wrong email format',
    kk: 'email форматы дұрыс емес',
  },
  actionHistoryLabel: {
    ru: 'История действий',
    en: 'Actions history',
    kk: 'Әрекеттер тарихы',
  },
  actionHistoryNotFound: {
    ru: 'Истории действий за данный период не найдено',
    en: 'No history of actions for this period',
    kk: 'Бұл кезең үшін әрекетер тарихы табылған жок',
  },
  action: {
    ru: 'Действие',
    en: 'Action',
    kk: 'Әрекет',
  },
  actionStatus: {
    ru: 'Статус',
    en: 'Status',
    kk: 'Жай-күйі',
  },
  admin: {
    ru: 'Администратор',
    en: 'Administrator',
    kk: 'Әкімші',
  },
  replacementDate: {
    ru: 'Дата замены Sim карты: ',
    en: 'Sim card replacement date: ',
    kk: 'SIM картаны ауыстыру күні: ',
  },
  months: {
    1: {
      ru: 'Январь',
      en: 'January',
      kk: 'Қаңтар',
    },
    2: {
      ru: 'Февраль',
      en: 'February',
      kk: 'Ақпан',
    },
    3: {
      ru: 'Март',
      en: 'March',
      kk: 'Наурыз',
    },
    4: {
      ru: 'Апрель',
      en: 'April',
      kk: 'Сәуір',
    },
    5: {
      ru: 'Май',
      en: 'May',
      kk: 'Мамыр',
    },
    6: {
      ru: 'Июнь',
      en: 'Jun',
      kk: 'Маусым',
    },
    7: {
      ru: 'Июль',
      en: 'July',
      kk: 'Шілде',
    },
    8: {
      ru: 'Август',
      en: 'August',
      kk: 'Тамыз',
    },
    9: {
      ru: 'Сентябрь',
      en: 'September',
      kk: 'Қыркүйек',
    },
    10: {
      ru: 'Октябрь',
      en: 'October',
      kk: 'Қазан',
    },
    11: {
      ru: 'Ноябрь',
      en: 'November',
      kk: 'Қараша',
    },
    12: {
      ru: 'Декабрь',
      en: 'December',
      kk: 'Желтоқсан',
    },
  },
  service_unavailable_4_your_tariff: {
    ru: 'Данная услуга недоступна для вашего тарифного плана.',
    en: 'This service is not available for your tariff plan.',
    kk: 'Бұл қызмет сіздің тарифтік жоспарыңыз үшін қол жетімді емес.',
  },
  not_enough_balance: {
    ru: 'Недостаточно средств для списания стоимости подключения услуги.',
    en: 'Not enough balance to cover the cost of service.',
    kk: 'Қызметті қосу үшін теңгерімдегі қаражат жеткіліксіз.',
  },
  work_performed_certificate: {
    ru: 'Акт выполненных работ',
    en: 'Certificate of work performed',
    kk: 'Орындалған жұмыстар актісі',
  },
  accountNumberSearch: {
    ru: 'Поиск по номеру лицевого счета',
    en: 'Search by account number',
    kk: 'Дербес шот нөмірі бойынша іздеу',
  },
  phoneNumberSearch: {
    ru: 'Поиск по номеру телефона',
    en: 'Search by phone number',
    kk: 'Телефон нөмірі бойынша іздеу',
  },
  year: {
    ru: 'Год',
    en: 'Year',
    kk: 'Жыл',
  },
  month: {
    ru: 'Месяц',
    en: 'Month',
    kk: 'Ай',
  },
  download: {
    ru: 'Загрузить',
    en: 'Download',
    kk: 'Жүктеу',
  },
  documentsNotFound4Msisdn: {
    ru: 'По номеру “77010542001” нет соответствующих документов.',
    en: 'There is no relevant documents for number “77010542001”.',
    kk: '“77010542001” нөміріне сәйкес құжат жоқ.',
  },
  to: {
    ru: 'по',
    en: 'to',
    kk: 'дейін',
  },
  from: {
    ru: 'с',
    en: 'from',
    kk: 'бастап',
  },
  deviceRegistration: {
    ru: 'Регистрация устройства (IMEI)',
    en: 'Device registration (IMEI)',
    kk: 'Құрылғыны тіркеу (IMEI)',
  },
  lastIMEI: {
    ru: 'Последний зафиксированный IMEI',
    en: 'The last IMEI',
    kk: 'Соңғы жазылған IMEI',
  },
  registrationStatus: {
    ru: 'Статус регистрации',
    en: 'Registration status',
    kk: 'Тіркеу жай-күйі',
  },
  register: {
    ru: 'Зарегистрировать',
    en: 'Register',
    kk: 'Тіркеу',
  },
  deviceRegistered: {
    ru: 'Устройство зарегистрировано',
    en: 'Device registered',
    kk: 'Құрылғы тіркелген',
  },
  deviceNotRegistered: {
    ru: 'Устройство не зарегистрировано',
    en: 'Device not registered',
    kk: 'Құрылғы тіркелмеген',
  },
  device: {
    ru: 'Устройство',
    en: 'Device',
    kk: 'Құрылғы',
  },
  deleteRegistration: {
    ru: 'Удалить',
    en: 'Delete',
    kk: 'Жою',
  },
  existingRegistrations: {
    ru: 'Существующие регистрации',
    en: 'Existing registrations',
    kk: 'Бар тіркеулер',
  },
  deviceRegisteredWithNumber: {
    ru: 'Устройство зарегистрировано с этим номером',
    en: 'The device is registered with this number.',
    kk: 'Құрылғы осы нөмірмен тіркелген.',
  },
  deviceNotRegisteredWithNumber: {
    ru: 'Устройство не зарегистрировано с этим номером',
    en: 'Device not registered with this number.',
    kk: 'Құрылғы осы нөмірмен тіркелмеген.',
  },
  sms_ussd_mgm_ban: {
    ru: 'Запрет на SMS / USSD управление',
    en: 'Ban on SMS / USSD control',
    kk: 'SMS / USSD арқылы басқаруға тыйым салу'
  },
  sms_ussd_mgm_ban_title: {
    ru: 'Запрет на SMS / USSD управление – это ограничение на самостоятельное управление абонентом тарифными планами, дополнительными услугами посредством коротких текстовых сообщений (SMS) и USSD-команд.',
    en: 'SMS / USSD control ban restricts user’s ability to manage their subscription plan and add-on services by means of short text messages (SMS) and USSD commands.',
    kk: 'SMS / USSD арқылы басқаруға тыйым салу -  бұл абоненттің қысқа мәтіндік хабарламалар (SMS) және USSD пәрмендері арқылы тарифтік жоспарларды, қосымша қызметтерді өз бетінше басқаруын шектеу.'
  },
  sms_ussd_mgm_ban_enabled_title: {
    ru: 'Запрет установлен. Хотите снять запрет?',
    en: 'The ban is set. Want to remove the ban?',
    kk: 'Тыйым салу орнатылған. Тыйым салуды алып тастағыңыз келе ме?'
  },
  sms_ussd_mgm_ban_disabled_title: {
    ru: 'Запрет не установлен. Хотите установить запрет?',
    en: 'No ban is set. Want to set a ban?',
    kk: 'Тыйым салу орнатылмаған. Тыйым салуды орнатқыңыз келе ме?'
  },
  set: {
    ru: 'УСТАНОВИТЬ',
    en: 'SET',
    kk: 'ОРНАТУ'
  },
  remove: {
    ru: 'СНЯТЬ',
    en: 'REMOVE',
    kk: 'АЛЫП'
  },
  call_forwarding: {
    ru: 'Переадресация',
    en: 'Call forwarding',
    kk: 'Қоңырауды бағыттау'
  },
  direction: {
    ru: 'Направление',
    en: 'Direction',
    kk: 'Сипаттама'
  },
  still_pending: {
    ru: 'Данная операция временно недоступна. Пожалуйста повторите попытку позднее.',
    en: 'This operation is temporarily unavailable. Please try again later.',
    kk: 'Бұл әрекет уақытша қол жетімді емес. Кейінірек қайталап көріңіз.'
  },
  msisdn_blocked: {
    ru: 'Операция недоступна на заблокированном номере.',
    en: 'Operation is not available on a blocked number.',
    kk: 'Бұл әрекет бұғаттаулы нөмірде қол жетімді емес.'
  },
  sms_ussd_mgm_ban_enable_success: {
    ru: 'Запрета на SMS / USSD управление успешно установлен',
    en: 'SMS/USSD control ban successfully set',
    kk: 'SMS-ке / USSD басқаруға тыйым салу сәтті орнатылды'
  },
  sms_ussd_mgm_ban_enable_failure: {
    ru: 'Произошла ошибка во время установки запрета на SMS / USSD управление',
    en: 'An error occurred while trying to set SMS/USSD control ban.',
    kk: 'SMS - ке/ USSD басқаруға тыйым салуды орнату кезінде қателік орын алды'
  },
  sms_ussd_mgm_ban_disable_success: {
    ru: 'Запрет на SMS / USSD управление успешно удален',
    en: 'SMS/USSD control ban successfully removed',
    kk: 'SMS-ке / USSD басқаруға тыйым салу сәтті жойылды'
  },
  sms_ussd_mgm_ban_disable_failure: {
    ru: 'Произошла ошибка во время удаления запрета на SMS / USSD управление',
    en: 'An error occurred while trying to remove SMS/USSD control ban',
    kk: 'SMS - ке/ USSD басқаруға  тыйым салуды жою кезінде қателік орын алды'
  },
  callforwardSetSuccess: {
    ru: 'Переадресация успешно установлена',
    en: 'Call Divert successfully set',
    kk: 'Бағыттау табысты орнатылды'
  },
  callforwardSetFailure: {
    ru: 'Произошла ошибка при установке переадресации',
    en: 'Error occurred while trying to set Call Divert',
    kk: 'Бағыттауды орнату барысында қателік орын алды'
  },
  callforwardRemoveSuccess: {
    ru: 'Переадресация успешно удалена',
    en: 'Call Divert successfully disabled',
    kk: 'Бағыттау табысты жойылды'
  },
  callforwardRemoveFailure: {
    ru: 'Произошла ошибка при удалении переадресации',
    en: 'An error occurred while trying to disable Call Divert',
    kk: 'Бағыттауды жою кезінде қателік орын алды'
  },
  device_register_success: {
    ru: 'Ваш запрос принят в обработку для проведения регистрации в государственной Базе данных идентификационных кодов абонентских устройств сотовой связи.  Ответ будет Вам направлен в виде SMS',
    en: 'Your request for registration with State Database of IMEI Codes has been accepted for processing. Please, wait for the reply SMS.',
    kk: 'Сіздің сұранымыңыз ұялы байланыстың абоненттік құрылғылары сәйкестендіру кодтарының мемлекеттік дерекқорында  тіркеу үшін өңдеуге қабылданды. Жауап Сізге SMS түрінде жіберіледі'
  },
  device_register_failure: {
    ru: 'Произошла системная ошибка при регистрации устройства',
    en: 'A system error occurred while trying to register the device',
    kk: 'Құрылғыны тіркеу кезінде жүйелік қате орын алды '
  },
  device_remove_success: {
    ru: 'Ваш запрос принят в обработку для снятия регистрации в государственной Базе данных идентификационных кодов абонентских устройств сотовой связи.  Ответ будет Вам направлен в виде SMS',
    en: 'Your request for remove registration with State Database of IMEI Codes has been accepted for processing. Please, wait for the reply SMS.',
    kk: 'Сіздің сұранымыңыз ұялы байланыстың абоненттік құрылғылары сәйкестендіру кодтарының мемлекеттік дерекқорында  тіркеуден шығару үшін өңдеуге қабылданды. Жауап Сізге SMS түрінде жіберіледі'
  },
  device_remove_failure: {
    ru: 'Произошла системная ошибка при удалении регистрации устройства',
    en: 'A system error occurred while trying to remove device registration',
    kk: 'Құрылғы тіркеуін жою  кезінде жүйелік қате орын алды'
  },
  invoice_register: {
    ru: 'Реестр счетов-фактур',
    en: 'Invoice register',
    kk: 'Шот-фактура тізімі'
  },
  deviceIsRegistered: {
    ru: "Устройство зарегистрировано",
    en: "Device is registered",
    kk: "Құрылғы тіркелген"
  },
  deviceIsRegisteredWhiteRnn: {
    ru: "Устройство зарегистрировано за ИИН, на который был зарегистрирован абонентский номер",
    en: "Device is registered with IIN of the registered owner of this mobile number",
    kk: "Құрылғы абоненттік нөмір тіркелген ЖСН нөміріне тіркелген"
  },
  deviceIsRegisteredWhiteAmnesty: {
    ru: "Устройство зарегистрировано, имеет неуникальный IMEI код. Не рекомендуется снимать регистрацию устройства",
    en: "Device is registered with a non-unique IMEI code. Do not remove registration.",
    kk: "Құрылғы тіркелген, бірегей емес IMEI коды бар. Құрылғыны тіркеуден шығармаған жөн."
  },
  deviceIsRegisteredWhiteProven: {
    ru: "Устройство зарегистрировано, имеет неуникальный IMEI код. Не рекомендуется снимать регистрацию устройства",
    en: "Device is registered with a non-unique IMEI code. Do not remove registration. If you intend to give is to someone else, you should transfer ownership of the device to that person.",
    kk: "Құрылғы тіркелген, бірегей емес IMEI коды бар. Құрылғыны тіркеуден шығармаған жөн, егер құрылғыны басқа тұлғаға бергіңіз келсе, қайта тіркеуді ұсынамыз."
  },
  deviceIsBlack: {
    ru: "Устройство заблокировано",
    en: "Device is  blocked",
    kk: "Құрылғы бұғатталған"
  },
  registrationRequestAccepted: {
    ru: "Ваш запрос принят в обработку для проведения регистрации в государственной Базе данных идентификационных кодов абонентских устройств сотовой связи.  Ответ будет Вам направлен в виде SMS",
    en: "Your request for registration with State Database of IMEI Codes has been accepted for processing. Please, wait for the reply SMS.",
    kk: "Сіздің сұранымыңыз ұялы байланыстың абоненттік құрылғылары сәйкестендіру кодтарының мемлекеттік дерекқорында  тіркеу үшін өңдеуге қабылданды. Жауап Сізге SMS түрінде жіберіледі"
  },
  registrationRemoveRequestAccepted: {
    ru: "Ваш запрос принят в обработку для снятия регистрации в государственной Базе данных идентификационных кодов абонентских устройств сотовой связи.  Ответ будет Вам направлен в виде SMS",
    en: "Your request for remove registration with State Database of IMEI Codes has been accepted for processing. Please, wait for the reply SMS.",
    kk: "Сіздің сұранымыңыз ұялы байланыстың абоненттік құрылғылары сәйкестендіру кодтарының мемлекеттік дерекқорында  тіркеуден шығару үшін өңдеуге қабылданды. Жауап Сізге SMS түрінде жіберіледі"
  },
  registrationIsRemoved: {
    ru: "Регистрация снята",
    en: "Registration removed",
    kk: "Осы құрылғы тіркеуден шығарылды"
  },
  deviceRegDisclaimer: {
    ru: <b>Ответ с результатом по запросу будет предоставлен в виде SMS-сообщения в течение 8 часов.</b>,
    en: <b>The results of your request will be sent via SMS within the next 8 hours.</b>,
    kk: <b>Сұраным бойынша нәтижемен жауап 8 сағаттың ішінде SMS-хабарлама түрінде беріледі.</b>
  },
  deviceRegWarning: {
    ru: <b>Результаты обработки запросов Вы можете просмотреть в разделе «История запросов».</b>,
    en: <b>To view your request results, go to Request History.</b>,
    kk: <b>Сұранымдарды өңдеу нәтижесін «Сұранымдар тарихы» бөлімінен көруіңізге болады.</b>
  },
  requestHistory: {
    ru: "История запросов",
    en: "Request history",
    kk: "Сұранымдар тарихы"
  },
  condition: {
    ru: "Состояние",
    en: "Condition",
    kk: "Жай-күйі"
  },
  devRegistration: {
    ru: "Регистрация устройств",
    en: "Registration of end-user devices",
    kk: "Құрылғыларды тіркеу"
  },
  date: {
    ru: "Дата",
    en: "Date",
    kk: "Күні"
  },
  deviceRegAppWasSend: {
    ru: "Заявка на регистрацию отправлена",
    en: "Request for registration has been sent.",
    kk: "Тіркеуге өтінім жіберілді"
  },
  deviceUnregAppWasSend: {
    ru: "Заявка на снятие регистрации отправлена",
    en: "Request to remove registration has been sent.",
    kk: "Тіркеуден шығаруға өтінім жіберілді  "
  },
  registrationFailure: {
    ru: "Регистрация прошла не успешно",
    en: "Registration failed.",
    kk: "Тіркеу сәтсіз өтті"
  },
  unregistrationFailure: {
    ru: "Снятие регистрации прошло неуспешно",
    en: "Failed to remove registration.",
    kk: "Тіркеуден шығару сәтсіз өтті "
  },
  m2mImeiRegistrationAlert: {
    ru: "Введенный Вами номер (M2M) используется только для устройств межмашинного взаимодействия. Согласно Правилам регистрации абонентских устройств сотовой связи данные устройства регистрации не подлежат",
    en: "The number you have entered is for M2M communication only. According to Mobile Device Registration Rules, M2M  devices are not subject to registration",
    kk: "Cіз енгізген нөмір (M2M)  тек машинааралық өзара әрекеттестік құрылғылары үшін пайдаланылады.   Абоненттік құрылғыларды тіркеу қағидаларына сәйкес бұл құрылғылар тіркелуге жатпайды"
  },
  showMsisdnList: {
    ru: "Показать список получателей",
    en: "Показать список получателей",
    kk: "Показать список получателей"
  },
  msisdnList: {
    ru: "Список получателей",
    en: "Список получателей",
    kk: "Список получателей"
  }
};
